
















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import AddressForm from '@/components/AddressForm.vue';
import { TextInput } from '@/components/FormInputs/FormInputs';

@Component({
	components: {
		AddressForm,
		TextInput,
	}
})
export default class DeceasedView extends Vue {
	private isLoading: boolean = true;

	public async created() {
		this.$store.commit('InterviewModule/updatePageName', 'Deceased');
		if (this.$route.params.refreshFormData) {
			await this.$store.dispatch('InterviewModule/getFormData', 'Deceased');
		}
		this.isLoading = false;
	}

	public get isDeathDateRejected(): boolean {
		const cutoffDate = this.getDeathDateCutoff();
		const date = new Date(Date.parse(this.getFormDataKey('LegalContact.DateOfDeath')));
		return date.getTime() <= cutoffDate.getTime();
	}

	public AddressToolTip: any = {
		"LegalContact.Address.AddressLine1": "The deceased personality must be domiciled in the State of New York at time of death in order to file the claim. Provide street address of deceased personality.",
		"LegalContact.Address.City": "The deceased personality must be domiciled in the State of New York at time of death in order to file the claim. Provide City of deceased personality.",
		"LegalContact.Address.StateCode": "The deceased personality must be domiciled in the State of New York at time of death in order to file the claim.",
		"LegalContact.Address.CountyCode": "The deceased personality must be domiciled in the State of New York at time of death in order to file the claim. Provide county of residence.",
		"LegalContact.Address.Zip": "The deceased personality must be domiciled in the State of New York at time of death in order to file the claim. Provide Zip Code of deceased personality.",
		"LegalContact.Address.CountryCode": "The deceased personality must be domiciled in the State of New York at time of death in order to file the claim."
	}

	public get AddressToolTip2Str(): string {
		return JSON.stringify(this.AddressToolTip);
	}
}
